//#region REACT
import { Component } from "react";
import { Popup } from "react-leaflet";
//#endregion

//#region COMPONENTS
import { NanoFlex } from "../../Elements/NanoFlex";
import Type from "../../Elements/Typography";
import MapModal from "./MapModal";
//#endregion

//#region UTILS
import { withTranslation } from "react-i18next";
//#endregion

class MapPopup extends Component {
  constructor(props) {
    super(props);

    var dateLessSevenDays = new Date();
    dateLessSevenDays.setDate(dateLessSevenDays.getDate() - 7);

    this.state = {
      showModal: false,
      priority: this.props.priority ?? "",
      name: this.props.name ?? "",
      dateFilter: dateLessSevenDays,
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  getColor(priority) {
    return priority === "3 - Medium" ||
      priority === "4 - Medium Low" ||
      priority === "5 - Low"
      ? "#FFC107"
      : priority === "2 - Medium High"
      ? "#FF8100"
      : priority === "1 - High"
      ? "#E53935"
      : "#2A6DEC";
  }

  getSeverityName(priority) {
    return priority === "3 - Medium" ||
      priority === "4 - Medium Low" ||
      priority === "5 - Low"
      ? "Low"
      : priority === "2 - Medium High"
      ? "Medium"
      : priority === "1 - High"
      ? "High"
      : "House";
  }

  render() {
    return (
      <Popup>
        <NanoFlex justifyContent={"flex-start"}>
          <Type.p className="popup-title">{this.props.t("severity")}</Type.p>
          <NanoFlex width="auto">
            <NanoFlex
              color={this.getColor(this.state.priority)}
              radius="10px"
              padding="2px"
              margin="0 10px 0 10px"
              width="5px"
              height="5px"
            ></NanoFlex>
            <Type.p className="severityName">
              {this.getSeverityName(this.state.priority)}
            </Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="popup-name">
          <Type.p>
            {this.props.t("map.seeMoreDetails")} {this.state.name}{" "}
            {this.props.t("map.house")}
          </Type.p>
        </NanoFlex>
        <button className="modalbutton" onClick={this.handleOpenModal}>
          {this.props.t("map.seeMore")}
        </button>
        <MapModal
          id={this.props.id}
          isOpen={this.state.showModal}
          name={this.state.name}
          incidents={this.props.incidents}
          loadingTable={this.props.loadingTable}
          color={this.getColor(this.state.priority)}
          severityName={this.getSeverityName(this.state.priority)}
          onShowModal={(e) => {
            this.setState({ showModal: e });
            if (!e) {
              var dynamicDate = new Date();
              dynamicDate.setDate(dynamicDate.getDate() - 7);
              this.props.onDateFilterChange(dynamicDate);
            }
          }}
          onDateFilterChange={(e) => {
            this.props.onDateFilterChange(e);
          }}
        ></MapModal>
      </Popup>
    );
  }
}

export default withTranslation()(MapPopup);
